module.exports = __webpack_public_path__ + "img/UTJOHV.a15655cb.png";